import { render, staticRenderFns } from "./CreateFolder.vue?vue&type=template&id=ee0cd97a&scoped=true"
import script from "./CreateFolder.vue?vue&type=script&lang=js"
export * from "./CreateFolder.vue?vue&type=script&lang=js"
import style0 from "./CreateFolder.vue?vue&type=style&index=0&id=ee0cd97a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee0cd97a",
  null
  
)

export default component.exports